document.addEventListener("DOMContentLoaded", function () {
  const Products = document.querySelectorAll(".mystery-boxes-pro");

  Products.forEach((item) => {
    item.addEventListener(
      "mouseenter",
      () => {
        item.classList.add("active");
      },
      { once: true }
    );
  });
});
